import { rebind, merge } from "../utils";
import { zigzag } from "../calculator";
import baseIndicator from "./baseIndicator";

const ALGORITHM_TYPE = "ZigZag";

export default function () {
  const base = baseIndicator()
    .type(ALGORITHM_TYPE)
    .accessor((d) => d.zigzag);

  const underlyingAlgorithm = zigzag();

  const mergedAlgorithm = merge()
    .algorithm(underlyingAlgorithm)
    .merge((datum, indicator) => {
      datum.zigzag = indicator;
    });

  const indicator = function (data, options = { merge: true }) {
    if (options.merge) {
      if (!base.accessor())
        throw new Error(
          `Set an accessor to ${ALGORITHM_TYPE} before calculating`,
        );
      return mergedAlgorithm(data);
    }
    return underlyingAlgorithm(data);
  };

  rebind(indicator, base, "id", "accessor", "stroke", "fill", "echo", "type");
  rebind(indicator, underlyingAlgorithm, "undefinedLength");
  rebind(indicator, underlyingAlgorithm, "options");
  rebind(indicator, mergedAlgorithm, "merge", "skipUndefined");

  return indicator;
}
